import React from "react";

import cSharp from "../assets/dotnet-vertical.png";
import css from "../assets/css-logo.png";
import html from "../assets/html5.png";
import java from "../assets/java.png";
import js from "../assets/JavaScript-logo.png";
import rea from "../assets/React-icon.svg.png";
import sql from "../assets/sql-logo.png";
import git from "../assets/github-mark.png";

function Skills() {
  return (
    <div name="skills" className="w-full h-screen bg-[#F3DFBF]">
      {/*Container*/}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline-block border-b-4 border-[#008148] text-[#008148]">
            Experience
          </p>
          <p className="py-4 text-lg">
            Si tratta di competenze tecniche che ho acquisito finora nel
            percorso di studio scolastico e autodidattico. Ovviamente non sto
            sostenendo di avere tutte le nozioni e competenze in queste
            tecnologie, ma sono fiducioso di poter ricoprire una posizione
            lavorativa che utilizzi una o più delle seguenti tecnologie cosi da
            migliorare la mia conoscenza e padronanza.
          </p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={html} alt="logo-html" />
            <p className="my-2">HTML</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={css} alt="logo-css" />
            <p className="my-2">CSS 3</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={js} alt="logo-js" />
            <p className="my-2">JavaScript(ES6+)</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={rea} alt="logo-rea" />
            <p className="my-4">React</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={java} alt="logo-java" />
            <p className="my-2">Java / Java EE / Spring</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={cSharp} alt="logo-csharp" />
            <p className="my-2">.NET / C#</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={sql} alt="logo-sql" />
            <p className="my-2">SQL</p>
          </div>
          <div className="shadow-md shadow-[#dbcdb8] hover:scale-110 duration-500">
            <img className="w-20 mx-auto" src={git} alt="logo-git" />
            <p className="my-2">GitHub</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
